// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `    .title_left {
        width: 100%;
        float: left;
        display: block;
    }
    .row {
        margin-right: -10px;
        margin-left: -10px;
    }
    .x_panel {
        position: relative;
        width: 100%;
        margin-bottom: 10px;
        padding: 10px 17px;
        display: inline-block;
        background: #fff;
        border: 1px solid #E6E9ED;
        -webkit-column-break-inside: avoid;
        -moz-column-break-inside: avoid;
        /* column-break-inside: avoid; */
        opacity: 1;
        transition: all .2s ease;
    }
    .x_content {
        padding: 0 5px 6px;
        position: relative;
        width: 100%;
        float: left;
        clear: both;
        margin-top: 5px;
    }
    .dataTables_wrapper {
        position: relative;
        clear: both;
        zoom: 1;
    }
    /* .dataTables_wrapper > .row {
        overflow: auto !important;
    } */
    .form-control {
        border-radius: 0;
        width: 100%;
    }`, "",{"version":3,"sources":["webpack://./src/Sidebar/InsuranceTypes.css"],"names":[],"mappings":"IAAI;QACI,WAAW;QACX,WAAW;QACX,cAAc;IAClB;IACA;QACI,mBAAmB;QACnB,kBAAkB;IACtB;IACA;QACI,kBAAkB;QAClB,WAAW;QACX,mBAAmB;QACnB,kBAAkB;QAClB,qBAAqB;QACrB,gBAAgB;QAChB,yBAAyB;QACzB,kCAAkC;QAClC,+BAA+B;QAC/B,gCAAgC;QAChC,UAAU;QACV,wBAAwB;IAC5B;IACA;QACI,kBAAkB;QAClB,kBAAkB;QAClB,WAAW;QACX,WAAW;QACX,WAAW;QACX,eAAe;IACnB;IACA;QACI,kBAAkB;QAClB,WAAW;QACX,OAAO;IACX;IACA;;OAEG;IACH;QACI,gBAAgB;QAChB,WAAW;IACf","sourcesContent":["    .title_left {\r\n        width: 100%;\r\n        float: left;\r\n        display: block;\r\n    }\r\n    .row {\r\n        margin-right: -10px;\r\n        margin-left: -10px;\r\n    }\r\n    .x_panel {\r\n        position: relative;\r\n        width: 100%;\r\n        margin-bottom: 10px;\r\n        padding: 10px 17px;\r\n        display: inline-block;\r\n        background: #fff;\r\n        border: 1px solid #E6E9ED;\r\n        -webkit-column-break-inside: avoid;\r\n        -moz-column-break-inside: avoid;\r\n        /* column-break-inside: avoid; */\r\n        opacity: 1;\r\n        transition: all .2s ease;\r\n    }\r\n    .x_content {\r\n        padding: 0 5px 6px;\r\n        position: relative;\r\n        width: 100%;\r\n        float: left;\r\n        clear: both;\r\n        margin-top: 5px;\r\n    }\r\n    .dataTables_wrapper {\r\n        position: relative;\r\n        clear: both;\r\n        zoom: 1;\r\n    }\r\n    /* .dataTables_wrapper > .row {\r\n        overflow: auto !important;\r\n    } */\r\n    .form-control {\r\n        border-radius: 0;\r\n        width: 100%;\r\n    }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
